import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Button, Divider, Modal } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "./styles.scss";
import PartnersTable from "./PartnersTable";
import NewButton from "../../../components/common/NewButton/NewButton";
import { Partner, PartnershipType } from "../../../types/genericType";
import NewPartner from "./NewPartner";
import { getInvestorsByPartnershipId } from "../../../services/partnershipService";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";

type PartnershipDetailsPropType = {
  selectedPartnership: PartnershipType;
  setShowDetails: Function;
  setOpenEditDrawer: Function;
};

const PartnershipDetails = (props: PartnershipDetailsPropType) => {
  const { selectedPartnership, setShowDetails, setOpenEditDrawer } = props;
  const [partnersData, setPartnersData] = useState<Partner[]>();
  const [selectedPartner, setSelectedPartner] = useState<Partner>(
    {} as Partner
  );
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const getAllPartners = () => {
    selectedPartnership?.id &&
      getInvestorsByPartnershipId(selectedPartnership?.id)
        .then((res) => {
          setPartnersData(res);
        })
        .catch((err) => {
          console.log(err);
        });
  };

  useEffect(() => {
    getAllPartners();
  }, [selectedPartnership]);

  return (
    <Box className="partnership-details-container">
      <Button className="back-button" onClick={() => setShowDetails(false)}>
        <ChevronLeftIcon className="back-icon"></ChevronLeftIcon>
        <Typography className="back-title">BACK TO PARTNERSHIPS</Typography>
      </Button>
      <Typography className="title"> {selectedPartnership?.name}</Typography>
      <Paper elevation={2} className="details-paper">
        <Box className="details-header">
          <Typography className="details-title">Details</Typography>
          <NewButton
            title="EDIT"
            handleBtnClick={() => {
              setOpenEditDrawer(true);
            }}
            type="outlined"
            removeIcon
          />
        </Box>
        <Divider className="details-divider" />
        <Box className="details-content">
          <Typography className="details-description">
            {selectedPartnership?.description}
          </Typography>
          <Typography className="details-address">
            {selectedPartnership?.apartment} {selectedPartnership?.address}{" "}
            {selectedPartnership?.city} {selectedPartnership?.state}{" "}
            {selectedPartnership?.zip} {selectedPartnership?.country}
          </Typography>
          <Box className="details-status">
            <Typography className="status-label">Status</Typography>
            <Typography className="status-value">
              {selectedPartnership?.isActive ? "Active" : "Inactive"}
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Paper elevation={2} className="partners-paper">
        <Box className="partners-header">
          <Typography className="partners-title">Partners</Typography>
          <NewButton
            handleBtnClick={() => {
              setSelectedPartner({} as Partner);
              handleOpen();
            }}
            title="ADD PARTNER"
            type="outlined"
          />
        </Box>
        <div className="partner-table">
          {partnersData && partnersData?.length > 0 && (
            <PartnersTable
              partnersData={partnersData}
              setOpen={setOpen}
              setSelectedPartner={setSelectedPartner}
            />
          )}
        </div>
      </Paper>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NewPartner
          selectedPartnership={selectedPartnership}
          setOpen={setOpen}
          selectedPartner={selectedPartner}
          setOnSuccess={setOnSuccess}
          setSnackbarMsg={setSnackbarMsg}
          getAllPartners={getAllPartners}
        />
      </Modal>
      <CustomSnackbar
        open={onSuccess}
        message={snackbarMsg}
        setOpen={setOnSuccess}
      />
    </Box>
  );
};

export default PartnershipDetails;
